import React, { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import CustomDialog from "../basic/Dialog";
import ic_close from "../../assets/icons/ic_close.svg";
import IconButton from "../basic/IconButton";
import { toast } from "react-toastify";
import { getPumaSquad, updatePumaUserSquad } from "../../api/api";

// DROPDOWN FOR PUMA SQUAD
export function SquadDropdown({ squad, answer, setAnswer }) {
  const [open, setOpen] = useState(true);

  return (
    <form className="w-full py-2">
      <select
        className={`w-full space-x-2 text-white text-xl font-light border-[2px] border-[#25272D] bg-[#2C2C32] rounded-lg items-center px-5 py-4`}
        onChange={(e) => {
          setAnswer(e.target.value);
        }}
        value={answer}
      >
        {squad?.map((name) => (
          <option value={name}>{name}</option>
        ))}
      </select>
    </form>
  );
}

// POPOVER FOR PUMA SQUAD
const PumaSquad = ({ open, close }) => {
  const [squad, setSquad] = useState([]);
  const [updateSquad, setUpdateSquad] = useState({});
  const [answer, setAnswer] = useState("");

  // getPumaSquad
  const getSquadData = async () => {
    console.log("Get Squad");
    const data = await getPumaSquad();
    console.log("getPumaSquad" + data);
    setSquad(data.squads);
  };

  // updatePumaSquadName
  async function postSelectedSquad() {
    let response = await updatePumaUserSquad({ squad: answer });
    if (response.success) {
      setUpdateSquad(response);
      toast("Squad Updated!, Please choose the any challenge to start", {
        type: "success",
      });
    } else {
      toast("Error selecting squad name", { type: "error" });
    }
  }

  useEffect(() => {
    getSquadData();
    // PostSelectedSquad();
  }, []);

  return (
    <>
      <CustomDialog show={open} close={close}>
        <Dialog.Panel
          className="bg-[#25272D] 
                                 relative transform 
                                 overflow-hidden 
                                 rounded-lg 
                                 text-left 
                                 shadow-xl 
                                 transition-all 
                                 sm:my-8 sm:w-full sm:max-w-lg
                                 lg:px-10 px-4
                                 lg:py-10 py:4"
        >
          <IconButton
            icon={ic_close}
            className="shadow-xl absolute top-0 -right-0"
            onClick={() => {
              close();
            }}
          />
          <div className="flex justify-center items-center text-[#FFFFFF] text-2xl font-poppins font-bold py-4 px-4">
            Select Your Squad
          </div>
          <p className="font-light text-sm py-4 text-white px-6">
            Squad Name
            <br />
            <SquadDropdown
              squad={squad}
              answer={answer}
              close={close}
              setAnswer={setAnswer}
            />
          </p>
          <div className="flex justify-center items-center lg:px-6 px-3 lg:py-3 py-2">
            <button
              className="flex justify-center items-center md:text-xl text-md font-bold md:px-10 md:py-3 rounded-2xl bg-primary-neonGreen text-[#0E0E11]"
              onClick={() => {
                // setShowNameDialog(true);
                // PostSelectedSquad()
                postSelectedSquad();
              }}
            >
              Start Workout
            </button>
          </div>
        </Dialog.Panel>
      </CustomDialog>
    </>
  );
};
export default PumaSquad;

// <Popover className={"relative w-full"}>
//                             <Popover.Button
//                                 className={`flex flex-row w-full  space-x-2 text-white border-[2px] border-[#25272D] bg-[#2C2C32] rounded-lg items-center px-5 py-2`}
//                             >
//                                 <p className="text-xl w-full text-left z-0">
//                                     { answer?
//                                       squad.find((element) => element.key == answer).value
//                                       : "SELECT SQUAD"
//                                     }

//                                 </p>
//                                 <Icon
//                                     icon={"akar-icons:chevron-down"}
//                                     className="text-[#FFFFFF]"
//                                 />
//                             </Popover.Button>
//                             <Transition
//                                 as={Fragment}
//                                 enter="transition ease-out duration-150"
//                                 enterFrom="opacity-0 translate-y-0"
//                                 enterTo="opacity-100 translate-y-1"
//                                 leave="transition ease-in duration-150"
//                                 leaveFrom="opacity-100 translate-y-1"
//                                 leaveTo="opacity-0 translate-y-0"
//                             >
//                                 <Popover.Panel
//                                     className={`absolute z-50 w-full -mt-1 p-4 space-y-2 flex flex-col text-[#040405] bg-[#FFFFFF] rounded-xl`}
//                                 >
//                                     { ( close=() => { setOpen(false) }  ) => squad?.map((name) => {
//                                         return(
//                                         <>
//                                         <p>{name}</p>
//                                         </>
//                                     )})}
//                                 </Popover.Panel>
//                             </Transition>
//                         </Popover>
